<template>
  <div :id="'card_' + media.id" :data-test="'card_' + media.id" class="media-card p-3">
    <article class="card card-hover media-card-section h-100 d-flex flex-column" @click="visitMedia(media)">
      <a class="media-card-thumbnail d-flex align-items-center justify-content-center media-3 rounded-top">
        <MediaThumbnail :media="media" />
      </a>
      <div class="card-body d-flex flex-column">
        <span class="fs-xs fw-bold nav-heading" :class="media.presenters && media.presenters.length > 0 ? 'media-card-header-text-multiline' : 'media-card-header-text-multiline-expanded'">
          <a role="button">{{ media.title }}</a>
        </span>
        <p v-if="media.network && normalizedColumns !== 12" class="card-text">
          <i class="fas fa-user-group"></i>
          {{ media.network.short_name }}
          <span v-if="media.type === 'video' && media.vimeo_error_status" class="badge bg-danger ms-4">
            {{ $t('network.errorUplaodingVimeo') }}
          </span>
          <span v-else-if="media.type === 'video' && !media.vimeo_sync_status" class="badge bg-info ms-4">
            {{ $t('network.uploadInProgress') }}
          </span>
        </p>
      </div>
      <div class="card-footer media-card-footer mt-auto">
        <!-- Simplified metadata section -->
        <div class="d-flex flex-column gap-1" style="font-size: 0.65rem; min-height: 1rem;">
          <!-- Date -->
          <div class="d-flex align-items-center text-muted">
            <i class="fas fa-calendar-alt me-1"></i>
            <span>{{ formatDate(media.publish_date || media.creation_date) }}</span>
          </div>
          <!-- Presenters section (always below date) -->
          <div v-if="media.presenters && media.presenters.length > 0" class="d-flex align-items-center mt-1 pointer">
            <div class="d-none d-md-block me-2">
              <div class="avatar avatar-xs">
                <img :src="media.presenters[0].image" :alt="media.presenters[0].name ? media.presenters[0].name.split(' ').filter(n => n).map(n => n[0]).join('.') : ''" class="avatar-img rounded-circle" />
              </div>
            </div>
            <div>
              <p class="presenter-facepile-text-xs mb-0">
                {{ $t('CardFull.presented-by') }} {{ media.presenters[0].name }}
                <span v-if="media.presenters.length > 1">
                  {{ $t('and-others', { num: media.presenters.length - 1 }) }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>
<script>
import MediaThumbnail from '@/components/commons/Media/Thumbnail.vue';
import moment from 'moment';
import { buildMediaViewUrl } from '@/utils/urlUtils.js';

export default {
  name: 'CardSmall',
  components: {
    MediaThumbnail,
  },
  props: {
    media: {
      type: Object,
      default: null,
    },
    columns: {
      type: [Number, Array],
      default: null,
    },
    index: {
      type: Number,
      default: null,
    },
    network: {
      type: Object,
      default: null,
    },
  },
  computed: {
    normalizedColumns() {
      if (Array.isArray(this.columns)) {
        return this.columns.length > 0 ? this.columns[0] : null;
      }
      return this.columns;
    },
  },
  methods: {
    visitMedia(m) {
      let route;
      if (m.type === 'collection') {
        let networkSlug = this.network && this.network.slug ? '/networks/' + this.network.slug + '/' : '/networks/';
        route = networkSlug + 'collections/' + m.slug;
      } else {
        route = buildMediaViewUrl(m, this.network);
      }
      if (m.permission === 'authorized' && !this.$auth.auth) {
        this.$bus.emit('show-sign-in', route, this.$t('auth.signInMessage.protectedMedia'));
      } else {
        window.open(route, '_blank');
      }
    },
    downloadFile(link) {
      let msg = this.$t('network.downloadFileAlert');
      let action = () => {
        window.open(link, '_blank');
      };
      this.showConfirmPrompt(action, msg);
    },
    formatDate(date) {
      if (!date) return '';
      return moment(date).format('MM-DD-YYYY');
    },
  },
};
</script>
<style scoped>
.media-card {
  top: 0px;
  visibility: visible;
  left: 0px;
  opacity: 1;
  transition-duration: 250ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: transform, opacity;
}
.card-img-top:hover {
  text-decoration: none;
}
.media-card-section {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.media-card-section .card-body {
  padding: 0.5rem 1rem 0.5rem 1rem;
}
.media-card-header-text-multiline {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.2;
  height: 2.4em;
}
.media-card-header-text-multiline-expanded {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.2;
  height: 4.8em;
}
.presenter-facepile-text-xs {
  font-size: 0.65rem;
  font-weight: 500;
  color: #005f9a;
  line-height: 1.1;
  letter-spacing: inherit;
  font-family: inherit;
  margin-bottom: 0;
}
/*Avatar*/
.avatar {
  font-size: 1rem;
  position: relative;
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
}
.avatar-xs {
  width: 1.25rem;
  height: 1.25rem;
  font-size: 0.8rem;
}
.avatar-xs img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.cursor-default {
  cursor: default;
}
.media-card-footer {
  background-color: var(--bs-light);
  padding: 0.5rem 1rem;
}
</style>